import React from 'react'
import { WtnColorsEnum } from 'types/global'

interface IconProps {
  stroke: string
  strokeWidth?: number
  fill: string
}

const StarIcon = ({ stroke, fill, strokeWidth = 1.5 }: IconProps) => (
  <svg width='40' height='40' viewBox='0 0 40 40' fill={fill} xmlns='http://www.w3.org/2000/svg'>
    <path
      d='m20 9 3.708 7.514L32 17.719l-6 5.848 1.417 8.258L20 27.926l-7.417 3.9L14 23.565 8 17.72l8.292-1.205L20 9z'
      strokeWidth={`${strokeWidth}`}
      stroke={stroke}
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
  </svg>
)

interface Props {
  isMember: boolean
  color?: WtnColorsEnum
}

const WatchlistBadge = ({ isMember, color = WtnColorsEnum.PRIMARY_ALT }: Props) => {
  return <StarIcon stroke={color} fill={isMember ? color : 'none'} />
}

export default WatchlistBadge
